import apiService from '../apiService'

const apiPath = '/system'

export const systemController = (configService) => {
	const service = apiService(configService)
	return {
		getWaitAll: () => {
			return service.get({
				url: `${apiPath}/get_wait_all`,
			})
		},
		getSelectPlanByQuo: (params) => {
			return service.get({
				url: `${apiPath}/get_all_select_plan_by_quo?quo_num=${params}`,
			})
		},
		getPlanByQuoVif: (params) => {
			return service.get({
				url: `${apiPath}/get-plan-by-quo-vif?quo_num=${params}`,
			})
		},
		getWaitByQuo: (params) => {
			return service.get({
				url: `${apiPath}/get_plancampaign_by_quonum?quo_num=${params.quo_num}`,
			})
		},
		updateSelectPlan: (params) => {
			return service.post({
				url: `${apiPath}/select-plan`,
				body: { ...params },
			})
		},
		savePlanAuto: (params) => {
			return service.post({
				url: `${apiPath}/save-plan-auto`,
				body: { ...params },
			})
		},
		savePlanAutoNew: (params) => {
			return service.post({
				url: `${apiPath}/save-plan-auto-new`,
				body: { ...params },
			})
		},
		savePlanKey: (params) => {
			return service.post({
				url: `${apiPath}/save-plan-key-vif`,
				body: { ...params },
			})
		},
		updatePlanKey: (params) => {
			return service.post({
				url: `${apiPath}/update-plan-key-vif`,
				body: { ...params },
			})
		},
		savePlanTax: (params) => {
			return service.post({
				url: `${apiPath}/save-plan-tax`,
				body: params,
			})
		},
		deleteWaitByQuo: (quoNum) => {
			return service.get({
				url: `${apiPath}/delete_wait_by_quonum?quo_num=${quoNum}`,
			})
		},
		findSelectPlan: (params) => {
			return service.post({
				url: `${apiPath}/find_select_plan`,
				body: params,
			})
		},
		getViFollowAll: (params) => {
			return service.post({
				url: `${apiPath}/get_vi_follow_all`,
				body: params,
			})
		},
		getSummary: (params) => {
			return service.post({
				url: `${apiPath}/get_vi_summary`,
				body: params,
			})
		},
		findCustomer: (params) => {
			return service.post({
				url: `${apiPath}/find-customer`,
				body: { params },
			})
		},
		findCustomerPrbInsur: (params) => {
			return service.post({
				url: `${apiPath}/find-customer-prb-ins`,
				body: { ...params },
			})
		},
		findCustomerTroFin: (params) => {
			return service.post({
				url: `${apiPath}/find-customer-trofin`,
				body: { ...params },
			})
		},
		activeInsuranceVif: (quo_num) => {
			return service.post({
				url: `${apiPath}/active-insurance-vif`,
				body: { quo_num },
			})
		},
		saveCreditSlipVif: (params) => {
			return service.post({
				url: `${apiPath}/save-credit-slip-vif`,
				body: params,
			})
		},
		getInvoiceVif: () => {
			return service.get({
				url: `${apiPath}/get-invoice-vif`,
			})
		},
		getInvoiceByCuscode: (cuscode) => {
			return service.get({
				url: `${apiPath}/get-invoice-cuscode?cuscode=${cuscode}`,
			})
		},
		cancelInsuranceVif: (params) => {
			return service.post({
				url: `${apiPath}/cancel-insurance-vif`,
				body: params,
			})
		},
		updateCancelInsuranceVif: (params) => {
			return service.post({
				url: `${apiPath}/upload-cancel-insurance-vif`,
				body: params,
			})
		},
		cancelWaitInsuranceVif: (quo_num) => {
			return service.post({
				url: `${apiPath}/cancel-wait-insurance-vif`,
				body: { quo_num },
			})
		},
		getWaitCancelInsuranceAdminVif: () => {
			return service.get({
				url: `${apiPath}/get-wait-cancel-insurance-admin-vif`,
			})
		},
		getAllInsuranceVif: ({ search }) => {
			return service.get({
				url: `${apiPath}/get-all-insurance-admin-vif?search=${search}`,
			})
		},
		saveInvoiceSlipAdminVif: (params) => {
			return service.post({
				url: `${apiPath}/save-invoice-slip-admin-vif`,
				body: params,
			})
		},
		logDataVif: (params) => {
			return service.post({
				url: `${apiPath}/log-data-vif`,
				body: params,
			})
		},
		getCompanyInsuranceQuantity: (params) => {
			const { startDate, endDate, cuscode, type } = params
			return service.get({
				url: `${apiPath}/get-company-insurance-qty?type=${type}&cuscode=${cuscode}&startDate=${startDate}&endDate=${endDate}`,
			})
		},
		getSystempayfileVif: (quo_num) => {
			return service.get({
				url: `${apiPath}/get-systempayfile-vif?quo_num=${quo_num}`,
			})
		},
		getCheckPayVif: (params) => {
			return service.post({
				url: `${apiPath}/get-checkpay-vif`,
				body: params,
			})
		},
		lockUserVif: (params) => {
			const { cuscode, status, remark = '' } = params
			return service.get({
				url: `${apiPath}/lock-user-vif?cuscode=${cuscode}&status=${status}&remark=${remark}`,
			})
		},
		createUserAdmin: (params) => {
			const { cuscode, countUser } = params
			return service.get({
				url: `${apiPath}/create_user_admin?cuscode=${cuscode}&countUser=${countUser}`,
			})
		},
		getUserAdmin: (cuscode) => {
			return service.get({
				url: `${apiPath}/get_user_admin?cuscode=${cuscode}`,
			})
		},
		createUser: (params) => {
			return service.post({
				url: `${apiPath}/create_wp_user`,
				body: params,
			})
		},
		getAllCountLot: () => {
			return service.get({
				url: `${apiPath}/get_all_count_lot`,
			})
		},
		getCuscodeByLot: (lot) => {
			return service.get({
				url: `${apiPath}/get_cuscode_by_lot?lot=${lot}`,
			})
		},
		getNewsBroadcast: () => {
			return service.get({
				url: `${apiPath}/get_news_broadcast`,
			})
		},
		checkPrbInsSame: (params) => {
			const { id_motor2, type } = params
			return service.get({
				url: `${apiPath}/check_prb_ins_same?id_motor2=${id_motor2}&type=${type}`,
			})
		},
		checkNotiOverdue: () => {
			return service.get({
				url: `${apiPath}/check_noti_overdue`,
			})
		},
		getUserProFiles: (cuscode) => {
			return service.get({
				url: `${apiPath}/get_user_profiles?cuscode=${cuscode}`,
			})
		},
		changPremissionVif: (params) => {
			return service.post({
				url: `${apiPath}/chang_premission_vif`,
				body: params,
			})
		},
		getWaitPremissionVif: () => {
			return service.get({
				url: `${apiPath}/get_wait_premission_vif`,
			})
		},
		saveBillSlipVif: (params) => {
			return service.post({
				url: `${apiPath}/save-bill-slip-vif`,
				body: params,
			})
		},
		getLogApiCompany: (params) => {
			const { search, chanel } = params
			return service.get({
				url: `${apiPath}/get-log-api-company?search=${search}&chanel=${chanel}`,
			})
		},
		checkDuplicateVif: (params) => {
			return service.post({
				url: `${apiPath}/check_duplicate_vif`,
				body: { ...params },
			})
		},
		getSlipCancelVif: (quo_num) => {
			return service.get({
				url: `${apiPath}/get_slip_cancel_vif?quo_num=${quo_num}`,
			})
		},
		getDetailPlanByQuoVif: (params) => {
			return service.post({
				url: `${apiPath}/get_detailplan_by_quonum_vif`,
				body: { ...params, updateTran: true },
			})
		},
		getDownlineSale: (params) => {
			return service.post({
				url: `${apiPath}/downline-sale-vif`,
				body: { ...params },
			})
		},
		getFollowAll: (params) => {
			return service.post({
				url: 'https://fininsurance.co.th:2022/api/v1/insurance/system/get_follow_all',
				body: params,
			})
		},
		getDetailPlanByQuo: (quo_num) => {
			return service.get({
				url: `https://fininsurance.co.th:2022/api/v1/insurance/system/get_detailplan_by_quonum?quo_num=${quo_num}`,
			})
		},
		getDetailFollow: (quo_num) => {
			return service.get({
				url: `https://fininsurance.co.th:2022/api/v1/insurance/system/get_detail_follow?quo_num=${quo_num}`,
			})
		},
		getTimelineStatus: (quo_num, prbOnly) => {
			return service.get({
				url: `${apiPath}/get_timeline_status?quo_num=${quo_num}${
					prbOnly ? '&prb_only=1' : ''
				}`,
			})
		},
		saveBillTax: (params) => {
			return service.post({
				url: `${apiPath}/save-bill-tax`,
				body: params,
			})
		},
		saveBillTaxAgain: (params) => {
			return service.post({
				url: `${apiPath}/save-bill-tax-again`,
				body: params,
			})
		},
		saveOrderTaxVIF: (params) => {
			return service.post({
				url: `${apiPath}/save-order-tax-vif`,
				body: params,
			})
		},
		rejectOrderTaxVif: (params) => {
			return service.post({
				url: `${apiPath}/reject-order-tax-vif`,
				body: params,
			})
		},
		saveSentDlt: (params) => {
			return service.post({
				url: `${apiPath}/save-sent-dlt`,
				body: params,
			})
		},
		cancelTaxVif: (params) => {
			return service.post({
				url: `${apiPath}/cancel-tax-vif`,
				body: params,
			})
		},
		nextStepVif: (params) => {
			return service.post({
				url: `${apiPath}/next-step-vif`,
				body: params,
			})
		},
		finalStepTaxVif: (params) => {
			return service.post({
				url: `${apiPath}/final-step-tax-vif`,
				body: params,
			})
		},
		saveDetailDiffer: (params) => {
			return service.post({
				url: `${apiPath}/save-detail-differ`,
				body: params,
			})
		},
		saveWorkProblem: (params) => {
			return service.post({
				url: `${apiPath}/save-work-problem`,
				body: params,
			})
		},
		saveFileBillTax: (params) => {
			return service.post({
				url: `${apiPath}/save-file-bill-tax`,
				body: params,
			})
		},
		saveBillTranTax: (params) => {
			return service.post({
				url: `${apiPath}/save-bill-tran-tax`,
				body: params,
			})
		},
		getDataOcr: (quo_num) => {
			return service.get({
				url: `${apiPath}/get_data_ocr?quo_num=${quo_num}`,
			})
		},
		getOutstandingBalanceHome: (params) => {
			return service.post({
				url: `${apiPath}/get-outstanding-balance-home`,
				body: params,
			})
		},
		checkUpdateFileOld: (idcar, carprovince, quo_num, have_prb, prb_policy) => {
			return service.get({
				url:
					`${apiPath}/check-update-file-old?idcar=${idcar}` +
					`&carprovince=${carprovince}&quo_num=${quo_num}` +
					`&have_prb=${have_prb}&prb_policy=${prb_policy}`,
			})
		},
		getDetailDiffer: (quo_num) => {
			return service.get({
				url: `${apiPath}/get-detail-differ?quo_num=${quo_num}`,
			})
		},
		saveRefStatement: (params) => {
			return service.post({
				url: `${apiPath}/save-ref-statement`,
				body: params,
			})
		},
		checkCancelStatement: (params) => {
			return service.post({
				url: `${apiPath}/check-cancel-statement`,
				body: params,
			})
		},
		checkEndorseStatement: (params) => {
			return service.post({
				url: `${apiPath}/check-endorse-statement`,
				body: params,
			})
		},
		saveCancelTask: (params) => {
			return service.post({
				url: `${apiPath}/save-cancel-task`,
				body: params,
			})
		},
		saveCreditReturnAdmin: (params) => {
			return service.post({
				url: `${apiPath}/save-Credit-Return-Admin`,
				body: params,
			})
		},
		saveCreditReturnAdminList: (params) => {
			return service.post({
				url: `${apiPath}/save-Credit-Return-Admin-List`,
				body: params,
			})
		},
		saveFinCreditVifReturnInsertList: (params) => {
			return service.post({
				url: `${apiPath}/save-Fin-Credit-Vif-Return-Insert-List`,
				body: params,
			})
		},
		resolveFinCreditVifReturnImport: (params) => {
			return service.post({
				url: `${apiPath}/resolve-Fin-Credit-Vif-Return-Import`,
				body: params,
			})
		},
		saveMatchListDebit: (params) => {
			return service.post({
				url: `${apiPath}/save-Match-List-Debit`,
				body: params,
			})
		},
		updatePrbTaxKey: (params) => {
			return service.post({
				url: `${apiPath}/update-prb-tax-Key`,
				body: { ...params },
			})
		},
		saveEndorseCusVif: (params) => {
			return service.post({
				url: `${apiPath}/save-endrose-cus-vif`,
				body: params,
			})
		},
		saveEndorseLineCusVif: (params) => {
			return service.post({
				url: `${apiPath}/save-endrose-line-cus-vif`,
				body: params,
			})
		},
		saveEndorseRejectAdmin: (params) => {
			return service.post({
				url: `${apiPath}/save-endrose-reject-admin`,
				body: params,
			})
		},
		saveEndorseSuccAdmin: (params) => {
			return service.post({
				url: `${apiPath}/save-endrose-succ-admin`,
				body: params,
			})
		},
		updateNotiEndorse: (params) => {
			return service.post({
				url: `${apiPath}/update-noti-endorse`,
				body: params,
			})
		},
		updateComPrbTaxKey: (params) => {
			return service.post({
				url: `${apiPath}/update-com-prb-tax-key`,
				body: params,
			})
		},
		getDetailDebitMatch: (invoice_no) => {
			return service.get({
				url: `${apiPath}/get-detail-debit-match?invoice_no=${invoice_no}`,
			})
		},
		getHasDriver: (company) => {
			return service.get({
				url: `${apiPath}/get-hasdriver?company=${company}`,
			})
		},
		saveDriverCustomer: (params) => {
			return service.post({
				url: `${apiPath}/save-driver-customer`,
				body: params,
			})
		},
		saveWaitDuppJobs: (params) => {
			return service.post({
				url: `${apiPath}/save-wait-dupp-jobs`,
				body: params,
			})
		},
		checkWaitDuppJobs: (params) => {
			return service.post({
				url: `${apiPath}/check-wait-dupp-jobs`,
				body: params,
			})
		},
		UnLockWaitDuppJobs: (params) => {
			const { quo_num } = params
			return service.get({
				url: `${apiPath}/unlock-wait-dupp-jobs?quo_num=${quo_num}`,
			})
		},
		saveTaskVif: (params) => {
			return service.post({
				url: `${apiPath}/save-task-vif`,
				body: params,
			})
		},
		changDataUserVif: (params) => {
			return service.post({
				url: `${apiPath}/chang_data_user_vif`,
				body: params,
			})
		},
		UploadQrSlip: (params) => {
			return service.post({
				url: `${apiPath}/upload-qr-slip`,
				body: params,
			})
		},
	}
}
